import { Severity } from '@sentry/browser';

export class CustomError extends Error {
  level: ErrorLevels = Severity.Critical;
  error: any;
  originalError: any;
  constructor(...args: any[]) {
    super(...args);

    // This way is how TS compiler likes (on test env only)
    [this.error, this.originalError] = args;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    } else {
      // JIC the polyfill does not work
      this.stack = new Error().stack;
    }
  }

  toString() {
    return `${this.error}`;
  }
  // eslint-disable-next-line
  get [Symbol.toStringTag]() {
    return `[LEASING_ERROR]`;
  }

  setErrorLevel(level: ErrorLevels) {
    this.level = level;
  }
}

export type ExceptionFormater = (...args: any[]) => string;
export type ErrorLevels = Severity;

export const getAPIErrorMessages: ExceptionFormater = e =>
  e.errors ? Object.values(e.errors).join('. ') : e.message || e;

// Thanks to https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5
export function retryPromise<T>(
  fn: () => Promise<T>,
  retriesLeft = 5,
  interval = 1000
) {
  return new Promise<T>((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retryPromise(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}

export const entityErrorsParser = (e: any) =>
  e && e.errors
    ? Object.entries(e.errors)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ')
    : '';
